import { SlideItemsCount } from '@/components/organisms/productsSlider/horizontalTitledProductsSlider'
import { Flex } from '@/components/atoms/Grid'
import { ProductSlide } from '@/components/organisms/productsSlider'
import { FC } from 'react'
import BaseSlider from '@/components/organisms/baseSlider'
import { ID } from 'graphql-ws'
import styled from 'styled-components'
import { lighten } from 'polished'
import Link from '@/components/atoms/link'

type CategorySliderItem = {
  id: ID
  title: string
  icon: JSX.Element
  url: string
}

type CategorySliderProps = {
  categories: CategorySliderItem[]
  slidesToShow?: SlideItemsCount
  slidesPerGroup?: SlideItemsCount
} & Rest

const CategorySlider: FC<CategorySliderProps> = ({
  categories,
  slidesPerGroup = { desktop: 1, tablet: 1, mobile: 1 },
  slidesToShow = { desktop: 7, tablet: 3, mobile: 2 },
  ...rest
}) => {
  return (
    <BaseSlider
      slidesToShow={slidesToShow}
      slidesPerGroup={slidesPerGroup}
      {...rest}
    >
      {categories &&
        categories.map((category) => (
          <ProductSlide key={category.id}>
            <StyledLink pt={2} href={category.url}>
              <StyledFlex
                m={10}
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                {category.icon}

                {category.title}
              </StyledFlex>
            </StyledLink>
          </ProductSlide>
        ))}
    </BaseSlider>
  )
}

export default CategorySlider

const StyledFlex = styled(Flex)`
  background: ${({ theme }) => lighten(0.95, theme.colors.onBackground)};
  height: 120px;
`

const StyledLink = styled(Link)`
  text-align: center;
`
